import callApi from "helpers/callApi";

export const getAllAttachements = async id => {
  return await callApi(`user_job_post_attachments?user_job_post_id=${id}`);
};
export const addAttachements = async data => {
  return await callApi("user_job_post_attachments", data, "POST");
};
